import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row align-items-center d-flex" }
const _hoisted_2 = { class: "col-12 col-md-6 document-input-field" }
const _hoisted_3 = { class: "col-12 col-md-6 document-input-switch" }
const _hoisted_4 = { class: "form-check form-switch mt-1 mb-2" }
const _hoisted_5 = {
  key: 0,
  id: "error-msg-container"
}

import { computed, onBeforeUnmount, reactive, ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { CPF_MASK, documentError, documentValue, formatCpf, FOREIGN_DOCUMENT_MASK } from "@/schemas/document";
import { useSessionStore } from "@/store/useSessionStore";
import type { TDocumentInputResponse } from "@/types";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { isCPFValid } from "@/utils/FormValidators";

// `initial`: valor de partida quando não há sessão (cadastro, ao voltar do passo 2)

export default /*@__PURE__*/_defineComponent({
  __name: 'DocumentInput',
  props: {
    initial: {}
  },
  emits: ["valueChanged"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const { session: userSession } = storeToRefs(useSessionStore());

const foreignDocument = ref(false);
const documentNumber = ref("");
// como o $dirty do vuelidate: o erro só aparece depois que o usuário mexe no campo
const dirty = ref(false);

const error = computed(() => documentError(documentNumber.value, foreignDocument.value));
const errorMessage = computed(() => error.value || "Informe um documento válido");

// formato de campo que o TextInput espera ($model/$error/$errors)
const documentModel = reactive({
  get $model() {
    return documentNumber.value;
  },
  set $model(v: string) {
    documentNumber.value = v;
    dirty.value = true;
  },
  get $error() {
    return dirty.value && !!error.value;
  },
  get $errors() {
    return error.value ? [{ $message: error.value }] : [];
  },
});

function setupDocument() {
  if (props.initial?.document) {
    foreignDocument.value = !!props.initial.foreigner;
    documentNumber.value = foreignDocument.value ? props.initial.document : formatCpf(props.initial.document);
    return;
  }
  const doc = userSession.value?.document_number || "";
  foreignDocument.value = !isCPFValid(doc) ? true : userSession.value?.foreigner || false;
  // quem mora no Brasil vê o CPF com máscara (000.000.000-00)
  documentNumber.value = foreignDocument.value ? doc : formatCpf(doc);
}
setupDocument();
EventBus.$on(EventBusNames.ACCOUNT_UPDATED, setupDocument);
onBeforeUnmount(() => EventBus.$off(EventBusNames.ACCOUNT_UPDATED, setupDocument));

// trocar "Resido fora do Brasil" troca a máscara: CPF formatado ↔ texto livre
watch(foreignDocument, (foreign) => {
  documentNumber.value = foreign ? documentValue(documentNumber.value, false) : formatCpf(documentNumber.value);
});

// avisa o pai a cada mudança (e já no início, como o watch do v$ legado)
watch(
  [documentNumber, foreignDocument],
  () =>
    emit("valueChanged", {
      // a API continua recebendo o CPF só com números
      values: { document: documentValue(documentNumber.value, foreignDocument.value), foreigner: foreignDocument.value },
      valid: !error.value,
    }),
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  const _component_TextInput = _resolveComponent("TextInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TextInput, {
        required: true,
        id: "register-document",
        label: foreignDocument.value ? 'Documento' : 'CPF',
        maxLength: 30,
        model: documentModel,
        type: "text",
        placeholder: foreignDocument.value ? 'Informe o número do documento' : 'Informe o CPF',
        errorMsg: errorMessage.value,
        mask: foreignDocument.value ? _unref(FOREIGN_DOCUMENT_MASK) : _unref(CPF_MASK)
      }, null, 8, ["label", "model", "placeholder", "errorMsg", "mask"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((foreignDocument).value = $event)),
          type: "checkbox",
          id: "register-foreigner-switch"
        }, null, 512), [
          [_vModelCheckbox, foreignDocument.value]
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("label", {
          class: "form-label text-muted small mb-0",
          for: "register-foreigner-switch"
        }, "Resido fora do Brasil", -1))
      ])
    ]),
    (!!error.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5))
      : _createCommentVNode("", true)
  ]))
}
}

})